import { useEffect, useState } from 'react';
import { leaderboardApi, LeaderRow } from '../api/leaderboard';
import { formatTon } from '../lib/format';

export function TopScreen() {
  const [rows, setRows] = useState<LeaderRow[] | null>(null);

  useEffect(() => {
    leaderboardApi.top(25).then(setRows).catch(() => setRows([]));
  }, []);

  return (
    <div className="stack">
      <div className="section-title">Топ игроков · 24 часа</div>
      {rows === null && <div className="muted" style={{ padding: 16 }}>Загрузка…</div>}
      {rows && rows.length === 0 && (
        <div className="muted" style={{ padding: 16 }}>Пока пусто — сыграй первым!</div>
      )}
      {rows?.map((r) => {
        const net = parseFloat(r.net);
        return (
          <div key={r.rank} className={`leader-row ${r.rank <= 3 ? `top3 r${r.rank}` : ''}`}>
            <span className="lr-rank">{r.rank}</span>
            <span className="lr-name">{r.name}</span>
            <span className="lr-wins muted">{r.wins} поб.</span>
            <span className="lr-net" style={{ color: net >= 0 ? 'var(--green)' : 'var(--red)' }}>
              {net >= 0 ? '+' : ''}
              {formatTon(r.net)}
            </span>
          </div>
        );
      })}
    </div>
  );
}
